'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculatePrices = calculatePrices;

var _claims = require('./claims');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Price = function Price() {
  _classCallCheck(this, Price);

  this.subtotal = 0;
  this.discount = 0;
  this.couponDiscount = 0;
  this.memberDiscount = 0;
  this.taxes = 0;
  this.total = 0;
};

function findTax(settings, country, type) {
  if (settings && settings.taxes) {
    for (var i in settings.taxes) {
      var tax = settings.taxes[i];
      if ((tax.countries == null || tax.countries.indexOf(country) > -1) && (tax.product_types == null || tax.product_types.indexOf(type) > -1)) {
        return tax;
      }
    }
  }
  return null;
}

function couponValidFor(claims, coupon, item) {
  if (!(0, _claims.checkClaims)(claims, coupon.claims)) {
    return false;
  }
  if (coupon.product_types && coupon.product_types.length) {
    return coupon.product_types.indexOf(item.type) > -1;
  }
  if (coupon.products && coupon.products.length) {
    return coupon.products.indexOf(item.sku) > -1;
  }
  return true;
}

function fixedAmount(amounts, currency) {
  var fixed = amounts && amounts.filter(function (amount) {
    return amount.currency === currency;
  })[0];
  return fixed && Math.round(parseFloat(fixed.amount) * 100) || 0;
}

function calculateDiscount(amountToDiscount, taxes, percentage, fixed, includeTaxes) {
  var discount = 0;
  if (includeTaxes) {
    amountToDiscount = amountToDiscount + taxes;
  }
  if (percentage > 0) {
    discount = Math.round(amountToDiscount * percentage / 100);
  }
  discount += fixed;

  if (discount > amountToDiscount) {
    return amountToDiscount;
  }
  return discount;
}

function calculatePrices(settings, claims, country, currency, coupon, items) {
  var price = new Price();
  var includeTaxes = settings && settings.prices_include_taxes;
  price.items = [];
  items && items.forEach(function (item) {
    var itemPrice = new Price();
    itemPrice.quantity = item.quantity || 1;
    itemPrice.subtotal = item.price.cents + (item.addonPrice ? item.addonPrice.cents : 0);

    var taxAmounts = [];
    if (item.vat) {
      taxAmounts.push({ price: itemPrice.subtotal, percentage: item.vat });
    } else if (settings && item.price.items && item.price.items.length) {
      item.price.items.forEach(function (priceItem) {
        var tax = findTax(settings, country, priceItem.type);
        if (tax) {
          taxAmounts.push({ price: priceItem.cents, percentage: tax.percentage });
        }
      });
    } else {
      var tax = findTax(settings, country, item.type);
      if (tax) {
        taxAmounts.push({ price: itemPrice.subtotal, percentage: tax.percentage });
      }
    }

    if (taxAmounts.length) {
      if (includeTaxes) {
        itemPrice.subtotal = 0;
      }
      taxAmounts.forEach(function (tax) {
        if (includeTaxes) {
          tax.price = Math.round(tax.price / (100 + tax.percentage) * 100);
          itemPrice.subtotal += tax.price;
        }
        itemPrice.taxes += Math.round(tax.price * tax.percentage / 100);
      });
    }

    if (coupon && couponValidFor(claims, coupon, item)) {
      itemPrice.discount = calculateDiscount(itemPrice.subtotal, itemPrice.taxes, coupon.percentage, fixedAmount(coupon.fixed, currency), includeTaxes);
      itemPrice.couponDiscount = itemPrice.discount;
    }
    if (settings && settings.member_discounts) {
      settings.member_discounts.forEach(function (discount) {
        if (couponValidFor(claims, discount, item)) {
          var memberDiscount = calculateDiscount(itemPrice.subtotal, itemPrice.taxes, discount.percentage, fixedAmount(discount.fixed, currency), includeTaxes);
          itemPrice.discount = itemPrice.discount || 0;
          itemPrice.discount += memberDiscount;
          itemPrice.memberDiscount = itemPrice.memberDiscount || 0;
          itemPrice.memberDiscount += memberDiscount;
        }
      });
    }

    itemPrice.total = Math.max(0, itemPrice.subtotal - itemPrice.discount + itemPrice.taxes);
    price.items.push(itemPrice);

    price.subtotal += itemPrice.subtotal * itemPrice.quantity;
    price.discount += itemPrice.discount * itemPrice.quantity;
    price.couponDiscount += itemPrice.couponDiscount * itemPrice.quantity;
    price.memberDiscount += itemPrice.memberDiscount * itemPrice.quantity;
    price.taxes += itemPrice.taxes * itemPrice.quantity;
    price.total += itemPrice.total * itemPrice.quantity;
  });

  return price;
}


//////////////////
// WEBPACK FOOTER
// ./~/gocommerce-js/lib/calculator.js
// module id = 723
// module chunks = 231608221292675